import { useMemo } from 'react';

const useValidatePassword = (password) => {
  const validation = useMemo(() => ({
    number: /\d/.test(password),
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    specialCharacter: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    minimumCharacters: password.length >= 6,
  }), [password]);

  return validation;
};

export default useValidatePassword;
